export default __webpack_public_path__ + "static/media/by_12.4ef8e14d.mp3";